import React from "react";
import { SingleGenre } from "pages";

const SingleGenreRoute = () => {
  return (
    <>
      <SingleGenre />
    </>
  );
};

export default SingleGenreRoute;
